import { useEffect, useState, useMemo, useCallback } from 'react';
import { Grid, TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useAppSnackbar } from '../../../component/providers/SnackbarProvider';
import { apiUrls } from '../../../constans/apiUrls';
import { useDialog } from '../../../context/dialog/DialogContext';
import { TIER_TYPES } from '../../../constans/parameter';
import DataGrid from '../../../component/ui/data-grid/DataGrid';
import Filter from '../../../component/ui/filter/filter';
import useApiService from '../../../component/hooks/useApiService';
import { userListColumns } from '../../../component/common/tableHelper';
import UserBoostsAssignmentsList from './UserBoostsAssignmentsList';

const UserBoostsList = () => {
    const [rows, setRows] = useState([]);
    const [filter, setFilter] = useState({});
    const { showSnackbar } = useAppSnackbar();
    const { openDialog } = useDialog();
    const [totalCount, setTotalCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { executeGet } = useApiService();
    const columns = useMemo(() => userListColumns(), []);

    const fetchData = async (filterParams = filter, page = paginationModel.page, pageSize = paginationModel.pageSize) => {
        setLoading(true);
        try {
            const response = await executeGet({
                url: apiUrls.User,
                params: {
                    ...filterParams,
                    offset: page * pageSize,
                    limit: pageSize,
                },
            });

            setRows(response.items ?? []);
            setTotalCount(response.meta?.total ?? 0);
        } catch (err) {
            console.error('Veri alınamadı:', err);
            setError('Veriler yüklenirken bir hata oluştu.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(filter, paginationModel.page, paginationModel.pageSize);
    }, [paginationModel.page, paginationModel.pageSize]);

    const handleReset = () => {
        const emptyFilter = {};
        setFilter(emptyFilter);
        setPaginationModel((prev) => ({ ...prev, page: 0 }));
        if (paginationModel.page === 0) {
            fetchData({}, 0);
        }
    };

    const onViewClicked = useCallback(
        (data) => {
            openDialog({
                title: "Kullanıcıya Tanımlanmış Boost Listesi",
                MaxWidth: 'xl',
                content: <UserBoostsAssignmentsList openType={"View"} data={data} />,
                callback: (res) => {
                    if (res.id) {
                        setPaginationModel((prev) => ({ ...prev, page: 0 }));
                        fetchData();
                        showSnackbar('Atanan boost kullanıldı.', 'info');
                    }
                },
            });
        },
        [filter]);

    const rowActions = useMemo(
        () => [
            {
                name: 'view',
                icon: 'view',
                tooltip: "Kullanıcı Boostlarını Görüntüle",
                onClick: onViewClicked
            }

        ],
        [filter]
    );

    const onRowActionVisible = (row, action) => {
        switch (action) {
            case 'view':
                return true;
            default:
                return false;
        }
    };

    return (
        <div style={{ padding: '0 1rem 1rem' }}>
            <h2>Kullanıcı Boost Listesi</h2>
            {error && <div style={{ color: 'red' }}>{error}</div>}

            <Filter
                onFilter={() => fetchData(filter)}
                onFilterReset={handleReset}
            >
                <Grid item xs={4}>
                    <TextField
                        fullWidth
                        name="Email"
                        label="Email"
                        variant="outlined"
                        value={filter?.email || ''}
                        onChange={(e) =>
                            setFilter({ ...filter, email: e.target.value })
                        }
                    />
                </Grid>

                <Grid item xs={4}>
                    <FormControl sx={{ minWidth: 220 }} variant="outlined">
                        <InputLabel id="tier-type-label">Kullanıcı Kategorisi</InputLabel>
                        <Select
                            labelId="tier-type-label"
                            id="tier-type"
                            value={filter?.tier_id || ''}
                            onChange={(e) =>
                                setFilter({ ...filter, tier_id: e.target.value })
                            }
                            label="Kullanıcı Kategorisi"
                        >

                            {TIER_TYPES.map((type) => (
                                <MenuItem key={type.Code} value={type.Code}>
                                    {type.ValueText1}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        fullWidth
                        name="MetaId"
                        label="Meta ID"
                        variant="outlined"
                        value={filter?.meta_id || ''}
                        onChange={(e) =>
                            setFilter({ ...filter, meta_id: e.target.value })
                        }
                    />
                </Grid>
                {/* <Grid item xs={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
            <DatePicker
              label="Oluşturulma Tarihi"
              value={filter?.LCIssueStartDate ? dayjs(filter.LCIssueStartDate) : null}
              onChange={(e) => {
                setFilter({ ...filter, LCIssueStartDate: e ? e.toISOString() : null });
              }}
              format="DD.MM.YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  sx: {
                    '& .MuiInputAdornment-root': {
                      marginLeft: '20px',
                    }
                  },
                },
              }}
            />
          </LocalizationProvider>
        </Grid> */}
            </Filter>

            <div style={{ width: '100%', marginTop: 20 }}>
                <DataGrid
                    rows={rows}
                    rowActions={rowActions}
                    columns={columns}
                    onRowActionVisible={onRowActionVisible}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[5, 10, 25, 50, 100]}
                    rowCount={totalCount}
                    paginationMode="server"
                    // checkboxSelection
                    loading={loading}
                    getRowId={(row, index) => row.id ?? index + 1}
                // onRowSelectionModelChange={(newSelection) => {
                //     const selectedRow = rows.find((row) => (row.id ?? row.Id) === newSelection[0]);
                //     setRowSelectionModel(selectedRow || "")
                // }}
                // rowSelectionModel={rowSelectionModel.id}
                />
            </div>
        </div>
    );
};

export default UserBoostsList;
